import React, { Component, useState ,useEffect} from 'react';
import { Link } from "react-router-dom";
import Axios from 'axios';
import Config  from "../Helpers/Config";
import Helpers from "../Helpers/Custom";
import Loader from "../../utils/Loader";
import { ElevatorSharp } from '@mui/icons-material';
const intialBcItems = [
  { "id":null,
    "name":"Home"}
]

function Reports() {
    const [fullData, setFullData] = useState({});
    const [folders, setFolders] = useState({});
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bcItems, setBcItems] = useState(intialBcItems);
    const [filterText, setFilterText] = useState("");
    const [main, setMain] = useState(true);

    useEffect(() => {
        fetchDetails();
        setBcItems(intialBcItems)
     }, [])

     const fetchDetailsByFolderId =(e,fromBc)=>{
         var id = e.currentTarget.dataset.folderid;
         setLoading(true)
         Axios.get(Config.api(`api/v2/reports?reportType=${id}`))
         .then( (response) => {
             setLoading(false)
             var dataset  = response.data;
             setDocs(dataset);
             if(!fromBc){
                var bc= bcItems;
                bc.push({
                    "id":id,
                    "name":id
                })
                setBcItems(bc)
            }
             setMain(false)
 
         })
         .catch((err) => {
             setLoading(false)
         });
       //  

       //  fetchDetails(id,false);
     }

     const fetchDetailsByFolderIdFromBc =(e)=>{
        var id = e.currentTarget.dataset.folderid;
        var index = e.currentTarget.dataset.index;
        checkBreadCrumb(index);
        if(Helpers.isEmpty(id)){
            fetchDetails(id,true);
            setMain(true)
        }else{
            fetchDetailsByFolderId(e)
            setMain(false)
        }
        
    }

     const checkBreadCrumb = (index)=>{
        var lclbcItems = bcItems;
        lclbcItems.splice(parseInt(index)+1, 9e9);
        setBcItems(lclbcItems);
     }

     const fetchDetails = (id,fromBc)=>{
        setLoading(true)
        Axios.get(Config.api("api/report-types"))
        .then( (response) => {
            setLoading(false)
            var dataset  = response.data;
            setFullData(dataset)
            setFolders(dataset)

        })
        .catch((err) => {
            setLoading(false)
        });
     }

     const filterDoc = (e)=>{
        var filterTextLcl = e.target.value;
        setFilterText(filterTextLcl)
     }


     console.log(folders,"!Helpers.isEmpty(folders)")

    return (
        <div className="container-fluid documents">
            <Loader loading={loading}/>
            <div className="col-xs-12 forms mt-5">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb m-t-10 doc-breadcrumb">
                        {
                            bcItems && bcItems.map((bcItem,i)=>(
                                <li className="breadcrumb-item"><a className="pointer" data-index={i} data-folderid={bcItem.id} onClick={fetchDetailsByFolderIdFromBc}>{bcItem.name == "Home" ? <i className="fa fa-home"></i> : <i className="fa fa-chevron-right"></i>}&nbsp;{bcItem.name}</a></li>
                            ))
                        }
                    </ol>
                </nav>
            </div>
           
            <div className="row mt-5" id="documentSearch">
                <div className="col-xs-12 col-md-4">
                    <div className="form-group">
                        <div className="input-group input-group-theme">
                            <div className="input-group-addon"><i className="material-icons mt-1">search</i></div>
                            <input type="text" className="form-control form-theme" placeholder={main ? "Search reports" : "Search documents"} id="docSearch" onChange={filterDoc} />
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div className={`row mt-3 ${main && !Helpers.isEmpty(folders) ? "folders" : ""}`}>
                {main && !Helpers.isEmpty(folders) && folders.filter(item => item.toLowerCase().includes(filterText.toLowerCase())).map((folder,i)=>(
                    <div className="col-xs-12 col-md-3" key={i+"folder"}>
                        <div className="theme-card">
                            <div className="card-body mt-1">
                                <ul className="list-inline clearfix">
                                    <li>
                                        <h3><i className='fa fa-folder-open'></i></h3>
                                         <h3 className="title-color title">{folder}</h3>
                                    </li>
                                </ul>
                                <div className="card-action">
                                    <a className="btn btn-theme viewBtn pointer" data-folderid={folder} data-foldername={folder} onClick={fetchDetailsByFolderId}><span className=' d-flex'>Explore</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                  ))
                }
             </div>
             
            
             {!main && !Helpers.isEmpty(docs) && <div className="col-md-12 mt-3 documents card no-border-radius">
                <div className="card-body">
                      <div className="row">
                         <h5 className="bordered doc-title">DOCUMENTS</h5>
                      </div>
                      <div className="row">
                          { 
                              docs.filter(item => item.name.toLowerCase().includes(filterText.toLowerCase())).map((doc,index)=>{
                                        return doc  ? <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 docCard" key={"doc"+index}>
                                                        <div class="document-grid">
                                                            <i class={Helpers.getFileIcon(doc?.name)+" display-6"}></i>
                                                            <h3 class="document-title mt-3">{doc?.name}</h3>
                                                            <div class="document-dates">
                                                                <span>Report as of Date: </span>
                                                                <span class="document-uploaded">{Helpers.getDateInInputFormat(doc?.updated)}</span>
                                                            </div>
                                                            <div class="document-dates">
                                                                <span>Published on: </span>
                                                                <span class="document-uploaded">{Helpers.getDateInInputFormat(doc?.updated)}</span>
                                                            </div>
                                                            <div class="card-action text-right mt-5">
                                                                <a class="btn btn-theme viewBtn" target="_blank" href={Helpers.viewReportURL(doc?.uuid)}>View</a>
                                                                <a class="btn btn-theme downloadBtn ms-1" target="_blank" download="download" href={Helpers.downloadReportURL(doc?.uuid)}>Download</a>
                                                            </div>
                                                            <p class="document-description"></p>

                                                        </div>
                                                    </div>
                                                    :
                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 docCard">No documents</div>
                                })
                                
                              
                           }
                      </div>
                </div>
             </div>}
         </div>
    )
}

export default Reports
